<template>
  <div class="modal-body p-0">
    <div
      v-for="payment in paymentMethodData"
      :key="payment.id"
      @click="checkPayment(payment.code)"
      :class="[
        'border px-3 py-3 rounded-lg mb-3 card', 
        selectPayment == payment.code ? 'border-primary' : '',
      ]"
    >
      <div class="d-flex align-items-center">
        <img
          :src="imagePayment(payment.code)"
          class="mr-2"
          height="30"
        >
        <div class="">
          <h6 class="font-weight-semibold mb-0">
            {{ $t(paymentName(payment)) }}
          </h6>
          <span 
            v-if="payment.code != 'BANK_TRANSFER' && selectPayment == payment.code"
            class="text-grey-300"
          >
            <i class="fa-solid fa-circle-info" />
            {{ $t('Once payment confirmation is received, the order will be effective immediately.') }}
          </span>
          <span 
            v-if="payment.code == 'BANK_TRANSFER' && selectPayment == payment.code"
            class="text-grey-300"
          >
            <i class="fa-solid fa-circle-info" />
            {{ $t('The system will take approximately 1 business day to verify the payment. Once confirmed, the order will be effective immediately.') }}
          </span>
        </div>
        <!-- <div class="ml-auto">
          <img
            :src="$storeIndex.getImageSrc('payment/' + payment.id)"
            :class="[ selectPayment != payment.id ? 'opacity-50' : '']"
            height="25"
          >
        </div> -->
      </div>
      <!-- <div
        :class="['show-banktransfer', selectPayment == payment.id ? 'open' : '']"
        v-if="payment.id == 'p4'"
      >
        <div
          id="payWithBankTransfer"
          class="payWithBankTransfer"
        >
          <div class="card-body">
            <div class="row">
              <div class="col-md-12">
                <div class="row">
                  <div class="col-md-12">
                    <h6>
                      {{ $t('Bank Account Information') }}
                    </h6>
                    <div class="row">
                      <div class="col-md-4">
                        <p>{{ $t('Bank') }}:</p>
                      </div>
                      <div class="col-md-6">
                        <img
                          class="mr-1"
                          height="25px"
                          :src="$storeIndex.getImageSrc('payment/Kbank_payment_logo')"
                          alt=""
                        >
                        <span style="color: #666;">Kasikornbank</span>
                      </div>
                      <div class="col-md-4">
                        <p>{{ $t('Account Number') }}:</p>
                      </div>
                      <div class="col-md-6">
                        <p style="color: #666;">
                          114-1-05649-9
                        </p>
                      </div>
                      <div class="col-md-4">
                        <p>{{ $t('Account Name') }}:</p>
                      </div>
                      <div class="col-md-6">
                        <p style="color: #666;">
                          Goship Company Ltd.
                        </p>
                      </div>
                      <div class="col-md-4">
                        <p>{{ $t('Amount') }}</p>
                      </div>
                      <div class="col-md-6">
                        <p style="color: #666;">
                          ฿{{ payAmount | formatNumber }}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12">
                    <div class="form-group">
                      <label>{{ $t("Amount") }} <span class="text-danger">*</span></label>
                      <input
                        type="number"
                        ref="amount"
                        step="0.01"
                        v-model="bankTransferForm.bank_amount"
                        :placeholder="$t('Enter amount...')"
                        class="form-control"
                        :class="{'is-invalid': $parent.submitted_formDeposit && $v.bankTransferForm.bank_amount.$error}"
                      >
                      <label
                        v-if="$parent.submitted_formDeposit && !$v.bankTransferForm.bank_amount.required"
                        class="validation-invalid-label"
                      >
                        {{ $t("Please enter amount") }}
                      </label>
                    </div>
                    <div class="form-group mb-0">
                      <div class="form-group">
                        <label>{{ $t("_AccountSetting.Upload Image") }}</label>
                        <vue-upload-multiple-image
                          :multiple="false"
                          :show-primary="false"
                          :max-image="limitImage"
                          @upload-success="uploadImageSuccess"
                          @before-remove="beforeRemove"
                          @edit-image="editImage"
                          id-upload="myIdUpload"
                          edit-upload="myIdEdit"
                          :drag-text="$t('Drag Images')"
                          :browse-text="$t('Browse Image')"
                          primary-text="Base image"
                          mark-is-primary-text="Set base image"
                          popup-text="default base image"
                          :drop-text="$t('Drag and drop')"
                          :class="[$parent.submitted_formDeposit && !$v.bankTransferForm.media.required ? 'border-1 border-danger border-dashed' : '',]"
                        />
                        <input
                          type="hidden"
                          class="form-control"
                          name="media"
                          v-model="bankTransferForm.media"
                          :class="{
                            'is-invalid':
                              $parent.submitted_formDeposit &&
                              $v.bankTransferForm.media.$error,
                          }"
                        >
                        <p
                          v-if="(!$v.bankTransferForm.media.required) && $parent.submitted_formDeposit"
                          class="validation-invalid-label"
                        >
                          {{ $t("Please enter images") }}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div> -->

      <!-- <div
        v-if="selectPayment == payment.id && payment.id == 'p1'"
        class="mt-2 pt-2 border-top mb-1"
      > -->
        <!-- <div
          v-if="payment.id == 'p1'"
          class="font-weight-semibold"
        >
          <div>{{ $t('Shipping Credit Total.') }}</div>
          <div
            class="text-success"
          >
            {{ $t('Balance ฿94,488.00') }}
          </div>
        </div>

        <div v-if="payment.id == 'creditCard'">
          <div class="font-weight-semibold">
            {{ $t('Online Payment Gateway') }}
          </div>
          <div class="d-inline-block border border-primary mt-2 px-3 py-2 rounded-xl text-center">
            <img
              :src="$storeIndex.getImageSrc('payment/payment')"
              class="ml-auto"
              height="20"
            >
            <div class="mt-2">
              {{ $t('2C2P / Visa / Master Card') }}
            </div>
          </div>
        </div> -->

        <!-- <div v-if="payment.id == 'p3'" class="d-flex align-items-center px-3 pt-2 pb-0">
                  <div>
                      <img :src="$storeIndex.getImageSrc('payment/dummy_qr_code')" class="ml-auto" height="160">
                      <div class="nowrap">
                          Please pay within <b>10</b> minutes.<br> Time remaining <span class="text-danger">{{ minute
                                          }}.{{ sec }}</span>
                      </div>
                  </div>
                  <div class="">
                      <ol class="line-height-lg">
                          <li>ดำเนินการแสกน QR Code ด้วย แอพพลิเคชั่นการชำระเงิน หรือ บันทึกรูปหน้าจอที่มีรูป QR Code และ เลือกรูปภาพ เพื่ออัพโหลด ด้วยแอพพลิเคชั่นการชำระเงิน ทำการชำระเงินด้วยตามยอดเงินที่ลูกค้าระบุในข้อมูลจากการแสกน
                          </li>
                          <li>
                              หากชำระเงินสำเร็จ ระบบจะยืนยันการชำระเงินและดำเนินการใน ขั้นตอนถัดไป
                          </li>
                          <li>
                              กรุณาชำระเงินภายใน 59 นาที หากเกินกำหนด รายการจะถูกยกเลิก และไม่สามารถทำรายการชำระเงินได้หากเกิน 60 นาที ท่านจะต้องทำรายการสั่งซื้อสินค้าเข้ามาใหม่
                          </li>
                          <li>
                              QR code มีระยะเวลาในการแสดงผล เพื่อทำการชำระเงินภายใน 10 นาที กรุณาทำรายการชำระเงิน ภายในเวลาที่กำหนด
                          </li>
                      </ol>
                  </div>
              </div> -->
        <!-- <div v-if="payment.id == 'p4'">
                  <div class="font-weight-semibold">{{ $t('Bank Account Information') }}</div>
                  <div class='mb-3'>
                      Bank: <img :src="$storeIndex.getImageSrc('payment/Kbank_payment_logo')" class="mx-1" height="20"> Kasikornbank
                      <br> Account Number: 114-1-05649-9<br> Account Name: บริษัท โกชิปป์ จำกัด
                  </div>
                  <div class="form-group">
                      <label>{{ $t("_AccountSetting.Amount") }} <span class="text-danger ml-1">*</span></label>
                      <input type="number" step="0.01" class="form-control" name="bank_amount" :placeholder="$t('Enter amount...')">

                  </div>
                  <div class="form-group mb-3">
                      <div class="form-group">
                          <label>{{ $t("_AccountSetting.Upload Image") }} <span class="text-danger ml-1">*</span></label>
                          <VueUploadMultipleImage :multiple="false" :showPrimary="false" :max-image="limitImage" @upload-success="uploadImageSuccess" @before-remove="beforeRemove" @edit-image="editImage" idUpload="myIdUpload" editUpload="myIdEdit" :dragText="$t('Drag Images')" :browseText="$t('Browse Image')" primaryText="Base image" markIsPrimaryText="Set base image" popupText="default base image" :dropText="$t('Drag and drop')" />

                      </div>
                  </div>
              </div>
              <div v-if="payment.id == 'p5'" class="font-weight-semibold">
                  <div>{{ $t('You have Received a Store Credit worth ฿100,000.00') }}</div>
                  <div class="text-success">{{ $t('Your Current Balance ฿50,500.00') }}</div>
              </div> -->
      <!-- </div> -->
      <span 
        v-if="selectPayment == payment.code"
        class="select-plan"
      >
        <i class="fa-solid fa-check" />
      </span>
    </div>
  </div>
</template>

<script>
// import VueUploadMultipleImage from '@/plugins/VueUploadMultipleImage.vue'
import numeral from "numeral";
import VueUploadMultipleImage from '@/plugins/VueUploadMultipleImage.vue'
// import VueUploadMultipleImage from 'vue-upload-multiple-image'
import Api from "@/services/endpoint/tenant.service.js";
import { required } from "vuelidate/lib/validators";
import moment from "moment";

export default {
    components: {
      VueUploadMultipleImage,
    },
    props: {
      payAmount  : {
        type: [Number, String],
        default: 0
      },
      paymentMethodData: {
        type: [Array, Object],
        default: null
      }
    },
    computed: {
      paymentMethod: function () {
        let currentTime = moment(this.$parent.timestamp)
        let startTime = moment('22:00', 'HH:mm').date(currentTime.date())
        let endTime = moment('07:00', 'HH:mm').date(currentTime.date()).add(1, 'day')
        currentTime.add(7, 'hours')

        let data = [{
          id: "p4",
          name: "Payment Via Bank Transfer"
        }]
        // if (currentTime.isBetween(startTime, endTime) || currentTime.isSame(startTime)) {
          data.push({
            id: "creditCard",
            name: "Payment Via Credit Card / Debit Card",  
          })
        // }
        
        return data
      }
    },
    data() {
        return {
            // selectPayment: "p4",
            selectPayment: "PROMTPAY_QRCODE",
            countDown: 0,
            minute: 9,
            sec: 59,
            // limitImage: 1,
            // limitImageSize: 1,
            // bankTransferForm: {
            //     bank_amount: '',
            //     media: ''
            // },
            loading: false,
            bankTransferForm: {
                bank_amount: this.payAmount,
                bank_account_transferor: "",
                media: [],
                image: '',
            },
            limitImage: 1,
            limitImageSize: 10,
            checkDeposit: false,
            submitted_formDeposit: false,
            checkingSlip: false,
            orders: {
                order_payment: {
                file: "",
                paid: "",
                },
            },
            defaultStartDate: moment().format('YYYY-MM-DD 09:00:00'),
            defaultEndDate: moment().format('YYYY-MM-DD 16:00:00'),
            dateNow: moment().format('YYYY-MM-DD HH:mm:ss'),
            isCheckTime: false

        }
    },
    mounted() {
      // let paymentMethod = "p4"
      // if(this.$parent.plan){
      //   paymentMethod = "p4"
      // }else if(this.$parent.$parent.previousPlan != undefined){
      //   if(this.$parent.$parent.previousPlan && this.$parent.$parent.previousPlan.payment_method_name == "Credit Card"){
      //     paymentMethod = "creditCard"
      //   }
      // }
      // this.checkPayment(paymentMethod);
      // console.log(this.$parent.$parent.previousPlan,'this.$parent.previousPlan555');
    },
    watch:{
      '$parent.ordersSummary.grandTotal'(newValue) {
          this.bankTransferForm.bank_amount = newValue;
        // console.log(newValue,'newValue');
        // console.log(this.bankTransferForm.bank_amount,'this.bankTransferForm.bank_amount');
      },
      bankTransferForm: {
        handler(val) {
          this.$parent.isInvalid = this.$v.bankTransferForm.$invalid;
          this.$parent.bankTransferForm = this.bankTransferForm;
        },
        deep: true,
      },
      'bankTransferForm.image'(path){
        if(path){
          this.checkSlip(path);
        }
      }
    },
    methods: {
        checkPayment(code) {
          this.selectPayment = code;
          this.$emit('selectPayment', code);
        },
        checkPaymentDateTime(code){
          let startTime = moment('09:00', 'HH:mm').date();
          let endTime = moment('16:00', 'HH:mm').date();
          this.dateNow.add(7, 'hours')
          // this.isCheckTime = false
          if(code == 'BANK_TRANSFER'){
            if(this.paymentMethodData.find((item) => item.code == 'PROMTPAY_QRCODE')){
              return this.dateNow <= startTime && this.dateNow >= endTime;
            }
          }
          return false;
        },
        async beforeRemove(index, done, fileList) {
          // done();
          // this.bankTransferForm.media = '';
          // this.bankTransferForm.image =  '';
          await this.$storeIndex.confirmRemoveFile(this, index, done, fileList)
        },
        callBackRemoveFile(status, index, done, fileList){
          if(status){
            done();
            this.bankTransferForm.media = '';
            this.bankTransferForm.image =  '';
          } else {}
        },
        editImage(formData, index, fileList) {
          // this.checkSlip(fileList);
          this.bankTransferForm.media = fileList;
          this.bankTransferForm.image = fileList[0].path;
        },
        async checkSlip(path){
          let params = {
              file: path
          }
          console.log(path,'fileList[0].path');
          // console.log(fileList,'fileList');
          this.checkingSlip = true;
          try {
            let response = await Api.AiSlip.postAiSlip(params);
            if (response.data.gcvApiStatus) {
                if (response.data.data.amount) {
                let data = response.data.data;
                this.bankTransferForm.bank_amount = data.amount;
                // this.$parent.ordersSummary.grandTotal = data.amount;
                } else {
                    this.$swal.fire({
                        title: this.$t("Cannot Detect") + " !",
                        icon: "warning",
                        iconColor: "#FF7043",
                        html: this.$t("Please check your payment slip."),
                        confirmButtonText: this.$t("OK"),
                        buttonsStyling: false,
                        customClass: {
                        confirmButton: "btn btn-primary",
                        cancelButton: "btn btn-light",
                        },
                        focusConfirm: false,
                    });
                }
            } else {
                this.$swal.fire({
                    title: this.$t("Cannot Detect") + " !",
                    icon: "warning",
                    iconColor: "#FF7043",
                    html: this.$t("AI service is not ready to use."),
                    confirmButtonText: this.$t("OK"),
                    buttonsStyling: false,
                    customClass: {
                        confirmButton: "btn btn-primary",
                        cancelButton: "btn btn-light",
                    },
                    focusConfirm: false,
                });
                this.sales_order_payment.paid_date = moment().format("YYYY-MM-DD HH:mm");
            }
          } catch (error) {
            this.$toastr.e(
              this.$t("Please upload other image or contact the staff"),
              "<span class='icon-blocked'></span>" + this.$t("Error")
            );
          }
        },
        uploadImageSuccess(formData, index, fileList, fileSize) {
          $(".image-container").css("margin-right", "0px");
          let imgSize = fileSize / 1000000;
          let imgList = fileList;

          if (index >= this.limitImage || imgSize > this.limitImageSize) {
              imgList.splice(index, 1);
              this.$toastr.w(this.$t("You can choose to upload a maximum of") +" "+ this.limitImage +" "+ this.$t("images")+"."+" "+ this.$t("The size is not over")+" "+this.limitImageSize+" MB.", "<span class='icon-warning22'></span>" + this.$t('Warning'));
              // this.$toastr.w(this.$t('Image Max limit Size'), "<span class='icon-warning22'></span>" + this.$t('Warning'));

          } else {
              // this.checkSlip(fileList);
          }

          this.bankTransferForm.media = imgList;
          this.bankTransferForm.image = fileList[0].path;
          // if (this.images) {
          //     this.bankTransferForm.media = this.images;
          //     // this.$parent.orders.order_payment.file = this.bankTransferForm.media[0].path;
          // }
          this.checkingSlip = false;
          // this.$emit('updateFileList', this.images);

        },
        paymentName(data){
          switch (data.code) {
            case 'PROMTPAY_QRCODE':
              return 'QR Promptpay';
              break;
            case 'CREDIT_DEBIT_CARD':
              return 'Credit / Debit Card';
              break;
            case 'BANK_TRANSFER':
              // if(this.paymentMethodData.find((item) => item.code == 'PROMTPAY_QRCODE')){
              //   return 'Bank Transfer (Available from 9:00 a.m. to 4:00 p.m.)';
              // }
              return '_Plan.Bank Transfer'
              break;
            default:
              return data.name;
              break;
          }
        },
        imagePayment(code){
          switch (code) {
            case 'PROMTPAY_QRCODE':
              return require('@/assets/images/payment/payment1.png');
              break;
            case 'CREDIT_DEBIT_CARD':
              return require('@/assets/images/payment/payment2.png');
              break;
            case 'BANK_TRANSFER':
              return require('@/assets/images/payment/payment3.png');
              break;
            default:
              return require('@/assets/images/no-image.png');
              break;
          }
        }

    },
    filters: {
      formatNumber: function (value) {
        return numeral(value).format("0,0.00");
      },
    },
    validations: {
      bankTransferForm: {
        bank_amount: {
          required
        },
        media: {
          required
        }
      }
    },
}
</script>

<style scoped>
.form-check {
    margin-bottom: 0;
}

.uniform-choice span:after {
    transition: none;
}

ol.line-height-lg>li {
    margin-bottom: 0.3125rem;
}
.show-banktransfer.open {
    display: block;
}
.show-banktransfer {
    display: none;
}
span.select-plan {
    position: absolute;
    bottom: 0;
    right: 0;
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 0 0 18px 18px;
    border-color: transparent transparent #007bff transparent;
}
span.select-plan>i,
span.select-plan>span {
    position: absolute;
    right: 2px;
    top: 9px;
    font-size: 7px;
    color: #fff;
}
.payment-disabled {
  pointer-events: none;
  opacity: 0.4;
}
</style>



// WEBPACK FOOTER //
// src/components/tenancy/admin/account-setting/premium-subscriptions/payment-modal/PaymentMethod.vue